import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { pipe } from "../../../../../utils/pipe.js";
import formatWithOptions from "date-fns/fp/formatWithOptions";
import startOfMonth from "date-fns/fp/startOfMonth";
import subYears from "date-fns/fp/subYears";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";
const localesByCode = {
  en: enLocale,
  de: deLocale
};
const getLocale = (language) => {
  if (!language)
    return localesByCode.en;
  return localesByCode[language];
};
const getStartOfMonthFiveYearsAgo = () => {
  return pipe(subYears(5), startOfMonth)(/* @__PURE__ */ new Date());
};
const toMonthAndYear = (date, config = {}) => {
  return formatWithOptions({ locale: getLocale(config.language) || localesByCode.en })(DATE_FORMATS.LOCAL_MONTH_YEAR)(
    date
  );
};
const toShortMonthFormat = (date, config = {}) => {
  return formatWithOptions({ locale: getLocale(config.language) || localesByCode.en })("dd MMM. yyyy")(date);
};
export {
  getLocale,
  getStartOfMonthFiveYearsAgo,
  toMonthAndYear,
  toShortMonthFormat
};
